import { IServiceResult } from "../../infrastructure/Interfaces/IServiceResult";
import { SVCParametros } from "../../infrastructure/services/api/SVCTransferencia";

export const ObtieneTransferencia = (selListaTransferencia: any,
    rutAlumno: number,
    idProcesoItemPago: number,
    numTransaccion: string,
    rutTitular: number,
    dvTitular: string,
    nombreTitular: string,
    idBanco: number,
    idTipoCuenta: number,
    correoTitular: string,
    montoPagado: number,
    guidHQB: string,
    idEstado: number,
    usuario: string
) => {
    let list: any = [];
    SVCParametros.ObtieneTransferencia(
        rutAlumno,
        idProcesoItemPago,
        numTransaccion,
        rutTitular,
        dvTitular,
        nombreTitular,
        idBanco,
        idTipoCuenta,
        correoTitular,
        montoPagado,
        guidHQB,
        idEstado,
        usuario
    ).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;


            selListaTransferencia(false, '', data);
        } else {
            selListaTransferencia(true, res.errorDetails, list);
        }
    });

};
export const ObtieneTransferenciaListado = (selListaTransferencia: any,
    codigoNegocio: number,
    rutAlumno: number,
    codSede: number,
    codCarrera: string,
    ano: number,
    periodo: number,
    idEstado: number
) => {
    let list: any = [];
    SVCParametros.ObtieneTransferenciaListado(
        codigoNegocio,
        rutAlumno,
        codSede,
        codCarrera,
        ano,
        periodo,
        idEstado
    ).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;


            selListaTransferencia(false, '', data);
        } else {
            selListaTransferencia(true, res.errorDetails, list);
        }
    });

};
export const InsertTransferencia = (selListaTransferencia: any,
    headers: any,
    rutAlumno: number,
    idProcesoItemPago: number,
    numTransaccion: string,
    rutTitular: number,
    dvTitular: string,
    nombreTitular: string,
    idBanco: number,
    idTipoCuenta: number,
    correoTitular: string,
    montoPagado: number,
    guidHQB: string,
    idEstado: number,
    usuario: string,
    idComprobante: number
) => {
    let list: any = [];
    SVCParametros.InsertTransferencia(
        headers,
        rutAlumno,
        idProcesoItemPago,
        numTransaccion,
        rutTitular,
        dvTitular,
        nombreTitular,
        idBanco,
        idTipoCuenta,
        correoTitular,
        montoPagado,
        guidHQB,
        idEstado,
        usuario,
        idComprobante
    ).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;


            selListaTransferencia(false, '', data);
        } else {
            selListaTransferencia(true, res.errorDetails, list);
        }
    });

};
export const ObtieneTieneTransferencia = (selListaTransferencia: any,
    idProceso: number,
    codigoItem: number
) => {
    let list: any = [];
    SVCParametros.ObtieneTieneTransferencia(
        idProceso,
        codigoItem
    ).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;


            selListaTransferencia(false, '', data);
        } else {
            selListaTransferencia(true, res.errorDetails, list);
        }
    });

};
export const UpdateTransferencia = (selListaTransferencia: any,
    idTransferencia: number
) => {
    let list: any = [];
    SVCParametros.UpdateTransferencia(
        idTransferencia
    ).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;


            selListaTransferencia(false, '', data);
        } else {
            selListaTransferencia(true, res.errorDetails, list);
        }
    });

};
export const DeleteTransferencia = (selListaTransferencia: any,
    idItemPago: number
) => {
    let list: any = [];
    SVCParametros.DeleteTransferencia(
        idItemPago
    ).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;


            selListaTransferencia(false, '', data);
        } else {
            selListaTransferencia(true, res.errorDetails, list);
        }
    });

};